import { render, staticRenderFns } from "./FAQCategoryEdit.vue?vue&type=template&id=8febbd78"
import script from "./FAQCategoryEdit.vue?vue&type=script&lang=js"
export * from "./FAQCategoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports